import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { NavItem, Nav, NavDropdown } from "react-bootstrap";

import banner_default from "../../assets/img/portoEduc_Bn_Videoteca_Home.jpg";

import { Query } from "react-apollo";
import gql from "graphql-tag";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import Paginator from "../../components/Paginator";

import { addToDataLayerGTM } from "../../utils/addToDataLayerGTM";

import HttpLinkServices from "../../services/HttpLinkServices";
import ErrorModal from "../../components/Modal/ErrorModal";

const lms_client = new ApolloClient({
  link: HttpLinkServices.lms,
  cache: new InMemoryCache()
});

const GET_VIDEO = gql`
  query getVideos($category_id: Int!, $limit: Int!, $page: Int!) {
    videos_collections_by_category(
      category_id: $category_id
      limit: $limit
      page: $page
    ) {
      videos {
        id
        title
        thumbnail
        is_viewed
      }
    }
  }
`;

const GET_CATEGORIES = gql`
  {
    video_categories_collections(parent_name: "Videoteca") {
      categories {
        id
        name
        hidden
        children {
          id
          name
          hidden
        }
      }
    }
  }
`;

class Video extends Component {
  constructor() {
    super();
    this.category_id = 0;
  }

  state = {
    page: 1,
    limit: 6,
    totalVideos: 0
  };

  contVideos() {
    lms_client
      .query({
        query: gql`
          query countVideos($category_id: Int!) {
            video_count(category_id: $category_id) {
              count
            }
          }
        `,
        variables: {
          category_id: this.props.match.params.category_id
            ? parseInt(this.props.match.params.category_id)
            : 3
        }
      })
      .then(result =>
        this.setState({ totalVideos: result.data.video_count.count })
      );
  }

  resetPage() {
    this.setState({ page: 1 });
  }

  componentDidMount() {
    this.contVideos();

    if (this.props.match.path === "/videoteca") {
      // Google Tag Manager
      const dataLayer = {
        event: "step_change",
        etapa: "/conteudos-digitais/videoteca/"
      };
      addToDataLayerGTM(dataLayer);
    }

    this.contVideos();
  }

  handleClickSubCategoriesGTM(category, subCategory) {
    //Google Tag Manager
    const dataLayer = {
      event: "step_change",
      etapa: `/conteudos-digitais/videoteca/'${category}/${subCategory}`
    };

    this.resetPage();

    addToDataLayerGTM(dataLayer);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.category_id !== this.props.match.params.category_id
    ) {
      this.contVideos();
    }
  }

  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }

  render() {
    return (
      <div className="">
        <img className="banner_content" src={banner_default} />

        <div className="container">
          <Grid fluid>
            <Row>
              <div className="contentMenu">
                <Nav>
                  <NavItem
                    data-gtm-type="click"
                    data-gtm-clicktype="submenu"
                    data-gtm-name="Todos"
                    href={"/#/videoteca/"}
                  >
                    Todos
                  </NavItem>
                  <Query client={lms_client} query={GET_CATEGORIES}>
                    {({ loading, error, data }) => {
                      if (loading) return <div>Carregando...</div>;
                      if (error) {
                        // Google Tag Manager
                        addToDataLayerGTM({
                          event: "erro",
                          descricao: "erro ao buscar categorias"
                        });
                        return <ErrorModal />;
                      }

                      if (!data.video_categories_collections.categories) {
                        return <div>(Vazio)</div>;
                      }

                      return data.video_categories_collections.categories.map(
                        categ =>
                          categ.hidden === "false" && (
                            <NavDropdown
                              eventKey={2}
                              title={categ.name}
                              id="basic-nav-dropdown-right"
                            >
                              {categ.children.map(
                                sub_categ =>
                                  sub_categ.hidden === "false" && (
                                    <NavItem
                                      data-gtm-type="click"
                                      data-gtm-clicktype="submenu"
                                      data-gtm-name={sub_categ.name}
                                      onClick={() =>
                                        this.handleClickSubCategoriesGTM(
                                          categ.name,
                                          sub_categ.name
                                        )
                                      }
                                      eventKey={sub_categ.id}
                                      href={
                                        "/#/videoteca-categoria/" + sub_categ.id
                                      }
                                    >
                                      {sub_categ.name}
                                    </NavItem>
                                  )
                              )}
                            </NavDropdown>
                          )
                      );
                    }}
                  </Query>
                </Nav>
              </div>
            </Row>
          </Grid>
          <Grid fluid>
            <Row>
              <Query
                client={lms_client}
                variables={{
                  category_id: this.props.match.params.category_id
                    ? parseInt(this.props.match.params.category_id)
                    : 3,
                  limit: this.state.limit,
                  page: this.state.page
                }}
                query={GET_VIDEO}
              >
                {({ loading, error, data }) => {
                  if (loading) return <div>Carregando...</div>;
                  if (error) {
                    // Google Tag Manager
                    addToDataLayerGTM({
                      event: "erro",
                      descricao: "erro ao buscar videos"
                    });
                    return <ErrorModal />;
                  }

                  if (!data.videos_collections_by_category.videos) {
                    return <div>(Vazio)</div>;
                  }

                  return data.videos_collections_by_category.videos.map(
                    item => (
                      <Col lg={4} sm={6}>
                        <div className="media">
                          <a
                            data-gtm-type="click"
                            data-gtm-clicktype="card"
                            data-gtm-name={item.title}
                            href={"/#/video/" + item.id}
                          >
                            <img src={item.thumbnail} />
                            <div>{item.title}</div>
                            {item.is_viewed ? (
                              <div className="is_viewed">Visualizado</div>
                            ) : (
                              ""
                            )}
                          </a>
                        </div>
                      </Col>
                    )
                  );
                }}
              </Query>

              <Col>
                <Paginator
                  currentPage={this.state.page}
                  pages={Math.ceil(this.state.totalVideos / this.state.limit)}
                  onChangePage={page => this.setState({ page })}
                  siblingCount={2}
                />
              </Col>
            </Row>
          </Grid>
        </div>
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/views/Videos/Videos.jsx